<app-navbar title="Relatórios e Análises - Relatório de Depósitos" />

<div class="py-8 px-4 overflow-y-auto max-h-[calc(100vh-5rem)] scrollbar-hide">
  <app-card>
    <app-card-header title="Relatório de Depósitos">
      <div class="flex flex-1 items-center justify-end flex-wrap gap-4">
        <form [formGroup]="filterForm" (ngSubmit)="getData()" class="flex items-center gap-3 flex-wrap">
          <p-floatlabel variant="on">
            <p-datepicker
              formControlName="initial_date"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              inputId="initial_date"
              appendTo="body"
            />
            <label for="initial_date">Data Inicial</label>
          </p-floatlabel>

          <p-button
            label="Aplicar"
            icon="fa-solid fa-filter"
            type="submit"
            [loading]="loading()"
            size="small"
          />

          <p-menu #exportMenu [model]="exportMenuItems" [popup]="true" appendTo="body" />
          <p-button
            icon="fa-solid fa-download"
            [outlined]="true"
            size="small"
            severity="secondary"
            (onClick)="exportMenu.toggle($event)"
            pTooltip="Exportar"
            tooltipPosition="bottom"
          />
        </form>
      </div>
    </app-card-header>

    <!-- Metrics Cards -->
    @if (!firstRequest() && !loading()) {
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 px-2">
        <div class="bg-blue-50 border border-blue-200 rounded-xl p-4">
          <div class="text-sm text-blue-600 font-medium">Total de Depósitos</div>
          <div class="text-2xl font-bold text-blue-800 mt-1">{{ totalDeposits() }}</div>
        </div>
        <div class="bg-emerald-50 border border-emerald-200 rounded-xl p-4">
          <div class="text-sm text-emerald-600 font-medium">Valor Total</div>
          <div class="text-2xl font-bold text-emerald-800 mt-1">{{ totalValue() | currency: 'BRL' : 'symbol' : '1.2-2' }}</div>
        </div>
        <div class="bg-amber-50 border border-amber-200 rounded-xl p-4">
          <div class="text-sm text-amber-600 font-medium">Valor Médio</div>
          <div class="text-2xl font-bold text-amber-800 mt-1">{{ avgValue() | currency: 'BRL' : 'symbol' : '1.2-2' }}</div>
        </div>
      </div>
    }

    <!-- Search Input -->
    @if (!firstRequest()) {
      <div class="mb-4 px-2">
        <div class="relative w-full md:w-80">
          <i class="fa-solid fa-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400"></i>
          <input
            type="text"
            pInputText
            placeholder="Buscar por nome, CPF, email ou ID..."
            class="w-full pl-10"
            (input)="onSearch($any($event.target).value)"
          />
        </div>
      </div>
    }

    <!-- Loading -->
    @if (loading()) {
      <div class="flex items-center justify-center py-20">
        <p-progressSpinner strokeWidth="3" />
      </div>
    }

    <!-- First Request Message -->
    @else if (firstRequest()) {
      <div class="flex flex-col items-center justify-center py-20 text-zinc-400">
        <i class="fa-solid fa-filter text-4xl mb-4"></i>
        <p class="text-lg">Selecione uma data e clique em "Aplicar" para visualizar os depósitos.</p>
      </div>
    }

    <!-- Empty State -->
    @else if (!filteredData().length) {
      <div class="flex flex-col items-center justify-center py-10 text-zinc-400">
        <div class="h-44">
          <ng-lottie [options]="emptyLottieOptions" />
        </div>
        <p>Nenhum depósito encontrado para o período selecionado.</p>
      </div>
    }

    <!-- Data Table -->
    @else {
      <p-table [value]="paginatedData()" [tableStyle]="{ 'min-width': '70rem' }">
        <ng-template #header>
          <tr>
            <th class="text-start text-sm">ID Jogador</th>
            <th class="text-start text-sm">CPF</th>
            <th class="text-start text-sm">Nome</th>
            <th class="text-start text-sm">Email</th>
            <th class="text-start text-sm">Último Depósito</th>
            <th class="text-end text-sm">Valor</th>
          </tr>
        </ng-template>
        <ng-template #body let-item>
          <tr>
            <td class="text-sm font-mono">{{ item.id_jogador }}</td>
            <td class="text-sm font-mono">{{ formatCpf(item.cpf) }}</td>
            <td class="text-sm">{{ item.nome }}</td>
            <td class="text-sm text-zinc-500">{{ item.email }}</td>
            <td class="text-sm">{{ item.data_ult_deposito }}</td>
            <td class="text-sm text-end font-semibold"
                [ngClass]="{
                  'text-emerald-600': item.valor_ultimo_deposito >= 100,
                  'text-zinc-800': item.valor_ultimo_deposito < 100
                }">
              {{ item.valor_ultimo_deposito | currency: 'BRL' : 'symbol' : '1.2-2' }}
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="6" class="text-center">
              <div class="h-44 p-4 text-zinc-500">
                <ng-lottie [options]="emptyLottieOptions" />
                Nenhum registro encontrado.
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #footer>
          <tr>
            <td colspan="6">
              <div class="w-full flex justify-end">
                <p-paginator
                  (onPageChange)="onPageChange($event)"
                  [rows]="rows"
                  [totalRecords]="totalRecords"
                  [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10, 25, 50, 100]"
                  currentPageReportTemplate="{first} - {last} de {totalRecords}"
                  appendTo="body"
                />
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </app-card>
</div>
